<template>
  <ul class="hot-news">
    <li
      v-for="(item, index) in list"
      :key="index"
      @click="cbDetail(item, index)"
      class="__flex __flex-vc __flex-cb"
    >
      <div class="news-left __flex __flex-cb" :class="[item.listImg? 'has-img': '']">
        <div class="title __ta-left __fs-17 __ellipsis __line2">
          <span class="hot_title">{{item.title}}</span>
          <img v-if="item.isFine===1" class="hot_img" src="@/assets/images/1_5_icon_hot.png">
        </div>
        <p class="source __line1 __ta-left __cor-8">{{item.source}}</p>
      </div>
      <div class="news-right __ta-right" v-if="item.listImg">
        <van-image
          class="news-img __ta-right"
          :src="formatAliyunPath(item.listImg)"
        />
      </div>
    </li>
  </ul>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'HotNews',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cbDetail (item, index) {
      this.$emit('cb-detail', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
.hot-news {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
  li {
    margin-top: 20px;
    .news-left {
      height: 78px;
      flex-direction: column;
      width: 100%;
      &.has-img {
        width: 208px;
      }
      .title {
        width: 100%;
        overflow: hidden;
        word-break: break-all;
        .hot_img{
          margin-left: 10px;
          white-space: nowrap;
        }
      }
      .source {
         width: 100%;
      }
    }
    .news-right {
      margin-left: 22px;
      .news-img {
        width: 105px;
        height: 78px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
